import { render } from "./status-info.vue?vue&type=template&id=8036c460"
import script from "./status-info.vue?vue&type=script&lang=js"
export * from "./status-info.vue?vue&type=script&lang=js"

import "./status-info.vue?vue&type=style&index=0&id=8036c460&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__